export enum PaymentTileEnum {
  GROSS_SALES = 'gross_sales_tile',
  PENDING_INVOICES = 'pending_invoices_tile'
}
